import React from "react"
import styled from "styled-components"
import { Card } from "components/atoms/Card"
import Typography from "components/_blueprint/Typography/Typography"
import { TextContent } from "../shared/StyledComponents"

const SectionContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 5px;
`

const StepsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

const StepItem = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 16px;
`

const StepNumber = styled.div`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background-color: ${({ theme }) => theme.colors.brand.primary};
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 14px;
  flex-shrink: 0;
`

const StepContent = styled.div`
  flex: 1;
`

const StepTitle = styled.h5`
  font-weight: 600;
  font-size: 16px;
  line-height: 1.5;
  color: ${({ theme }) => theme.colors.text.primary};
  margin: 0 0 4px 0;
`

const StepDescription = styled.p`
  font-weight: 500;
  font-size: 14px;
  line-height: 1.6;
  color: ${({ theme }) => theme.colors.text.secondary};
  margin: 0;
`

const CardStyleOverrides = {
  borderRadius: "24px",
}

const steps = [
  {
    title: "Recommendation call",
    description: "Your expert will present the best mortgage deals for you.",
  },
  {
    title: "Application",
    description: "We'll help you submit your application to the chosen lender.",
  },
  {
    title: "Lender process",
    description: "The lender will conduct their checks and property valuation.",
  },
  {
    title: "Completion",
    description: "Once approved, we'll guide you to completion and moving day.",
  },
]

export const WhatToExpectNextCard: React.FC = () => (
  <Card
    theme="default"
    style={CardStyleOverrides}
    content={
      <SectionContent>
        <TextContent>
          <Typography.H4 margin="0 0 16px 0">What to expect next</Typography.H4>
        </TextContent>

        <StepsContainer>
          {steps.map(({ title, description }, index) => (
            <StepItem key={title}>
              <StepNumber>{index + 1}</StepNumber>
              <StepContent>
                <StepTitle>{title}</StepTitle>
                <StepDescription>{description}</StepDescription>
              </StepContent>
            </StepItem>
          ))}
        </StepsContainer>
      </SectionContent>
    }
  />
)
